import { Divider } from 'antd';

export default function HeatMapDetails({ heatMap, pageNumber }) {
  return (
    <div className="heatmap-details">
      <div className="page-number">Page {pageNumber}</div>
      <div className="spent-time">{formatSpentTime(heatMap)}</div>
      <div className="viewed-count">{formatViewedCount(heatMap)}</div>
      <Divider />
      <div className="viewed-percentage">{formatViewedPercentage(heatMap)}</div>
    </div>
  );
}

const formatSpentTime = (data) => {
  const minutes = data?.minutes || 0;
  const seconds = data?.seconds || 0;

  if (minutes === 0 && seconds === 0) {
    return (
      <>
        <b>Time spent:</b> 0 sec
      </>
    );
  }

  let result = '';

  if (minutes > 0) {
    result += `${minutes}m `;
  }

  if (seconds > 0) {
    result += `${seconds}s`;
  }

  return (
    <>
      <b>Time spent:</b> {result.trim()}
    </>
  );
};

const formatViewedCount = (data) => {
  const count = data?.count || 0;
  return (
    <>
      <b>Views:</b> {count}
    </>
  );
};

const formatViewedPercentage = (data) => {
  return `${data?.percentage || 0} %`;
};
